import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import {Col, FormGroup, Input, Label, Row} from 'reactstrap';
import _ from 'lodash';
import PropTypes from 'prop-types';
import {Validacao} from "../../../comum/components/Validacao";
import Select from "react-select";
import {createSelectOptions, formatTelefone, getByAtribute} from "../../../../utils/formatar";
import NumberFormat from "react-number-format";
import DatePicker from "react-datepicker";
import moment from "moment";
import {LoadingBlockFields} from "../../../comum/components/LoadingBlockFields";
import {Alerta} from "../../../comum/components/Alerta";

@inject("store")
@observer
export class DadosMOTSubstituidoForm extends Component {

    static propTypes = {
        controller: PropTypes.object
    };

    constructor(props) {
        super(props);
        this.loginStore = this.props.store.loginStore;
    }

    render() {
        const solicitacaoSubstituicao = this.props.controller.solicitacaoSubstituicao.dadosMot;
        const controller = this.props.controller;
        const dadosMot = controller.solicitacaoEtt.dadosMot;
        const razaoOptions = createSelectOptions(this.props.controller.motivosSubstituicao, "nome", "nome");
        const razaoSubstituicao = this.props.controller.solicitacaoSubstituicao.razao;
        const dataInicioSubstituicao = this.props.controller.solicitacaoSubstituicao.dataSolicitacao;
        const tiposSanguineo = ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"];
        const tipoSanguineoOptions = tiposSanguineo.map(tipoSanguineo => {return {value: tipoSanguineo, label: tipoSanguineo}});
        const ufs = ["AC", "AL", "AP", "AM", "BA", "CE", "DF", "ES", "GO", "MA", "MT", "MS", "MG", "PA", "PB", "PR", "PE", "PI", "RJ", "RN", "RS", "RO", "RR", "SC", "SP", "SE", "TO"]
        const ufOptions = ufs.map(uf => {return {value: uf, label: uf}});
        const razaoSubstituicaoMOTEditavel = this.props.controller.razaoSubstituicaoMOTEditavel;
        const isEttLogada = this.loginStore.usuarioLogado && this.loginStore.usuarioLogado.perfilEtt;;
        const momentDataInicioSubstituicao = this.props.controller.momentDataInicioSubstituicao;
        const obstrucaoValidacaoCPF = this.props.controller.obstrucaoValidacaoCPF;
        const alertaValidacaoCPF = this.props.controller.alertaValidacaoCPF;
        const momentAntesDataTermino = this.props.controller.momentAntesDataTermino;
        let momentDepoisDataInicio = this.props.controller.momentDepoisDataInicio;
        if(!this.loginStore.isPerfilAdministradorLogado) {
            if (moment().isAfter(momentDepoisDataInicio))
                momentDepoisDataInicio = moment()
        }

        return (
            <div>
                <h4>Novo MOT</h4>
                <Row>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Razão substituição</Label>
                            {this.props.controller.razaoEDataSubstituicaoMOTEditavel ? (
                                <div>
                                    <Select simpleValue value={razaoSubstituicao}
                                            options={razaoOptions}
                                            onChange={(value) => this.props.controller.setRazaoSubstituicao(value)}
                                            noResultsText="Nenhum resultado encontrado" placeholder="Selecione..."
                                            multi={false}
                                    />
                                    <Validacao id="razaoSubstituicao" valor={razaoSubstituicao} tipo={["isRequired"]}/>
                                </div>
                            ) : (
                                <Input type="text" value={razaoSubstituicao} readOnly />
                            )}
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            {this.props.controller.razaoEDataSubstituicaoMOTEditavel ? (
                                <div>
                                    <Label>Data início substituição <sup>*</sup></Label>
                                    <DatePicker
                                        ref="dataInicio"
                                        onClickOutside={()=>{this.refs.dataInicio.cancelFocusInput(); this.refs.dataInicio.setOpen(false);}}
                                        locale={"pt_BR"}
                                        className="form-control"
                                        dateFormat="DD/MM/YYYY"
                                        selectsStart
                                        selected={momentDataInicioSubstituicao}
                                        startDate={momentDepoisDataInicio}
                                        minDate={momentDepoisDataInicio}
                                        maxDate={momentAntesDataTermino}
                                        onChange={(value) => this.props.controller.setDataSubstituicao(value)}
                                        onChangeRaw={(e) => this.props.controller.setDataInicioSubstituicaoCheck(e.target.value)}
                                    />
                                    <Validacao id="dataInicioSubstituicao" valor={this.props.controller.dataInicioSubstituicaoValidacao} tipo={["isRequired", "isDate"]}/>
                                </div>
                            ) : (
                                <div>
                                    <Label>Data início substituição</Label>
                                    <Input type="text" value={dataInicioSubstituicao ? moment(dataInicioSubstituicao).format("DD/MM/YYYY") : ""} readOnly />
                                </div>
                            )}
                        </FormGroup>
                    </Col>
                </Row>
                {isEttLogada &&
                <LoadingBlockFields carregando={this.props.controller.loadingCpfSubstituicao}>
                    <Row>
                        <Col xs={12} md={6} lg={4}>
                            <FormGroup>
                                <Label>CPF <sup>*</sup></Label>
                                <NumberFormat className="form-control" format="###.###.###-##"
                                              value={solicitacaoSubstituicao.cpf}
                                              onChange={(event, values) => controller.setCpfSubstituicao(dadosMot.cpf, values.value)} />
                                <Validacao id="complementoCPFSubstituicao" valor={solicitacaoSubstituicao.cpf} tipo={["isRequired", "isCPF", "mesmoCPF", dadosMot.cpf]} />
                                <div>
                                    {(obstrucaoValidacaoCPF && obstrucaoValidacaoCPF.length > 0) ? (
                                        <Alerta id={"alertaSubCpfMOT"} alertas={obstrucaoValidacaoCPF} isBloqueante/>
                                    ) : alertaValidacaoCPF && alertaValidacaoCPF.length > 0 &&
                                        <Alerta id={"alertaSubCpfMOT"} alertas={alertaValidacaoCPF} isBloqueante={false}/>
                                    }
                                </div>
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={6} lg={4}>
                            <FormGroup>
                                <Label>Nome completo <sup>*</sup></Label>
                                <Input type="text" maxLength={128} value={solicitacaoSubstituicao.nome} onChange={(event) => controller.setNomeSubstituicao(event.target.value)}/>
                                <Validacao id="complementoNomeSubstituicao" valor={solicitacaoSubstituicao.nome} tipo={["isRequired"]} />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={6} lg={4}>
                            <FormGroup>
                                <Label>E-mail {!solicitacaoSubstituicao.telefone && <sup>*</sup>}</Label>
                                <Input type="text" maxLength={256} value={solicitacaoSubstituicao.email} onChange={(event) => controller.setEmailSubstituicao(event.target.value)} />
                                {!solicitacaoSubstituicao.telefone ? (
                                    <Validacao id="complementoEmailSubstituicao" valor={solicitacaoSubstituicao.email} tipo={["isRequired", "isEmail"]} />
                                ) : (
                                    <Validacao id="complementoEmailSubstituicao" valor={solicitacaoSubstituicao.email} tipo={["isEmail"]} />
                                )}
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={6} lg={4}>
                            <FormGroup>
                                <Label>Telefone contato {!solicitacaoSubstituicao.email && <sup>*</sup>}</Label>
                                <NumberFormat className="form-control" maxLength={11 + 4}
                                              format={(value) => formatTelefone(value)} value={solicitacaoSubstituicao.telefone}
                                              onChange={(event, values) => controller.setTelefoneSubstituicao(values.value)}
                                />
                                {!solicitacaoSubstituicao.email &&
                                <Validacao id="complementoContatoSubstituicao" valor={solicitacaoSubstituicao.telefone} tipo={["isRequired"]}/>
                                }
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={6} lg={4}>
                            <FormGroup>
                                <Label>Identidade <sup>*</sup></Label>
                                <Input type="text" className="form-control" maxLength={16} value={solicitacaoSubstituicao.identidade}
                                       onChange={(event) => controller.setIdentidadeSubstituicao(event.target.value)}
                                />
                                <Validacao id="complementoIdentidadeSubstituicao" valor={solicitacaoSubstituicao.identidade} tipo={["isRequired"]}/>
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={6} lg={4}>
                            <FormGroup>
                                <Label>Orgão emissor <sup>*</sup></Label>
                                <Input type="text" maxLength={32} value={solicitacaoSubstituicao.orgaoEmissor}
                                       onChange={(event) => controller.setOrgaoEmissorSubstituicao(event.target.value)}
                                />
                                <Validacao id="complementoOrgaoEmissorSubstituicao" valor={solicitacaoSubstituicao.orgaoEmissor}
                                           tipo={["isRequired"]}/>
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={6} lg={4}>
                            <FormGroup>
                                <Label>Rua <sup>*</sup></Label>
                                <Input type="text" maxLength={256} value={solicitacaoSubstituicao.endereco.rua}
                                       onChange={(event) => controller.setEnderecoRuaSubstituicao(event.target.value)}/>
                                <Validacao id="complementoRuaSubstituicao" valor={solicitacaoSubstituicao.endereco.rua} tipo={["isRequired"]}/>
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={6} lg={4}>
                            <FormGroup>
                                <Label>Número</Label>
                                <Input type="number" min="1" onKeyPress={(event) => {return event.charCode >= 48 && event.charCode <= 57 ? '' : event.preventDefault()}} maxLength={8}
                                       value={solicitacaoSubstituicao.endereco.numero} onChange={(event) => controller.setEnderecoNumeroSubstituicao(event.target.value)} />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={6} lg={4}>
                            <FormGroup>
                                <Label>Complemento</Label>
                                <Input type="text" maxLength={256} value={solicitacaoSubstituicao.endereco.complemento} onChange={(event) => controller.setEnderecoComplementoSubstituicao(event.target.value)} />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={6} lg={4}>
                            <FormGroup>
                                <Label>Bairro <sup>*</sup></Label>
                                <Input type="text" maxLength={128} value={solicitacaoSubstituicao.endereco.bairro} onChange={(event) => controller.setEnderecoBairroSubstituicao(event.target.value)} />
                                <Validacao id="complementoBairroSubstituicao" valor={solicitacaoSubstituicao.endereco.bairro} tipo={["isRequired"]} />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={6} lg={4}>
                            <FormGroup>
                                <Label>Cidade <sup>*</sup></Label>
                                <Input type="text" maxLength={128} value={solicitacaoSubstituicao.endereco.cidade} onChange={(event) => controller.setEnderecoCidadeSubstituicao(event.target.value)} />
                                <Validacao id="complementoCidadeSubstituicao" valor={solicitacaoSubstituicao.endereco.cidade} tipo={["isRequired"]} />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={6} lg={4}>
                            <FormGroup>
                                <Label>UF <sup>*</sup></Label>
                                <Select value={solicitacaoSubstituicao.endereco.uf} options={ufOptions}
                                        onChange={(value) => controller.setEnderecoUFSubstituicao(value)}
                                        noResultsText="Nenhum resultado encontrado" placeholder="Selecione..."
                                        multi={false}/>
                                <Validacao id="complementoUFSubstituicao" valor={solicitacaoSubstituicao.endereco.uf} tipo={["isRequired"]} />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={6} lg={4}>
                            <FormGroup>
                                <Label>CEP <sup>*</sup></Label>
                                <NumberFormat className="form-control" format="#####-###" value={solicitacaoSubstituicao.endereco.cep} onChange={(event, values) => controller.setCEPSubstituicao(values.value)} />
                                <Validacao id="complementoCEPSubstituicao" valor={solicitacaoSubstituicao.endereco.cep} tipo={["isRequired"]} />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={6} lg={4}>
                            <FormGroup>
                                <Label>Tipo sanguíneo <sup>*</sup></Label>
                                <Select value={solicitacaoSubstituicao.tipoSanguineo} options={tipoSanguineoOptions}
                                        onChange={(value) => controller.setTipoSanguineoSubstituicao(value)}
                                        noResultsText="Nenhum resultado encontrado" placeholder="Selecione..."
                                        multi={false} />
                                <Validacao id="complementoTipoSanguineoSubstituicao" valor={solicitacaoSubstituicao.tipoSanguineo} tipo={["isRequired"]} />
                            </FormGroup>
                        </Col>
                    </Row>
                </LoadingBlockFields>
                }
            </div>
        )
    }
}